export default __webpack_public_path__ + "static/media/Matikkaeditori.fi.5d7a4655.png";